import * as React from 'react';

import { TH } from 'security-app/components/common';

function ListHeader() {
  return (
    <>
      <colgroup>
        <col style={{ width: '20%' }} />
        <col style={{ width: 'auto' }} />
      </colgroup>
      <thead>
        <tr>
          <TH>Title</TH>
          <TH>Description</TH>
        </tr>
      </thead>
    </>
  );
}

export default ListHeader;
